import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useCallback, useRef } from 'react';

export const TestList = ({ suiteId }) => {
  const rsrc = useRsrc();
  const entityListRef = useRef();

  const clientSideRowData = useCallback((setDataSource) => {
    const reqParam = {
      entity: 'TEST',
      joinEntity: 'SUITE_TEST',
      filterEntity: 'SUITE',
      filterEntityId: suiteId,
    };

    rsrc.data('ac', 'MANY_TO_MANY_DATA_PLUGIN', reqParam, 'TEST').then((res) => {
      setDataSource(res);
    });
  }, []);

  const augFieldDefs = (fieldToFieldDef) => {
    // If in the context of a Suite, the tests will come ordered by seq, so no need to sort by verStartInstant
    if (suiteId) {
      fieldToFieldDef.verStartInstant.sort = null;
      fieldToFieldDef.seq = { field: 'seq', displayName: 'Seq', precedence: -999 };
    }

    fieldToFieldDef.description.maxWidth = 500;
  };

  return (
    <EntityList
      ref={entityListRef}
      entity="TEST"
      augFieldDefs={augFieldDefs}
      clientSideRowData={suiteId ? clientSideRowData : null}
      gridOptions={{
        rowDragManaged: true,
        animateRows: true,
      }}
    />
  );
};
